import type { GroundStats } from "../shared/ground";
import type { MapId } from "../shared/maps";
import type { RoundStats } from "../shared/score";

export interface LeaderboardEntry {
  name: string;
  score: number;
  achievedAt: number;
}

export interface SubmitResult {
  score: number;
  best: number;
  rank: number;
  personalBest: boolean;
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { "content-type": "application/json", ...init?.headers },
  });
  const body = (await res.json().catch(() => null)) as { error?: { message?: string } } | null;
  if (!res.ok) throw new Error(body?.error?.message ?? `Request failed (${res.status})`);
  return body as T;
}

export function startRound(name: string, map: MapId): Promise<{ roundId: string }> {
  return call("/api/rounds", { method: "POST", body: JSON.stringify({ name, map }) });
}

export function submitScore(roundId: string, score: number, stats: RoundStats | GroundStats): Promise<SubmitResult> {
  return call(`/api/rounds/${roundId}/score`, { method: "POST", body: JSON.stringify({ score, stats }) });
}

export async function fetchLeaderboard(map: MapId): Promise<LeaderboardEntry[]> {
  return (await call<{ entries: LeaderboardEntry[] }>(`/api/leaderboard?map=${map}`)).entries;
}
